// src/hooks/useFetchReferentialServices.tsx
import { useState, useEffect } from 'react';
import config from '../config';
import { ApiServiceResponse, ServiceFilterCriteria } from '../interfaces';
import { useSession } from '../contexts/SessionContext';

const useFetchReferentialServices = (filterCriteria: ServiceFilterCriteria) => {
  const [apiResponse, setApiResponse] = useState<ApiServiceResponse>({ result: [], total: 0 });
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const refetch = () => setRefreshTrigger(prev => prev + 1);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        // Filter out keys with empty values
        const nonEmptyFilterCriteria = Object.fromEntries(
          Object.entries(filterCriteria).filter(([_, value]) => value !== '')
        );

        // Create query parameters string
        const queryParams = new URLSearchParams(nonEmptyFilterCriteria).toString();
        const token = sessionState.account?.token;
        const response = await fetch(`${config.centralApiBaseUrl}/referential/service?index=0&nbItems=50&descOrder=false&${queryParams}`, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
          }
        });


        if (!response.ok) {
          throw new Error('Failed to fetch items');
        }

        const data = await response.json();
        setApiResponse(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      }
    };

    fetchDevices();
  }, [filterCriteria, sessionState, refreshTrigger]);

  return { apiResponse, error, refetch };
};

export default useFetchReferentialServices;
